import React from 'react';
import { useTranslation } from 'react-i18next';

export const ReferenceInfo = () => {
  const { t } = useTranslation();

  return (
    <>
      {t('epdWizard.wizardStep2.info.referenceFlows.ref1')}
      <br />
      <br />
      {t('epdWizard.wizardStep2.info.referenceFlows.ref2')}
    </>
  );
};
